import Vue from 'vue';
import Router from 'vue-router';

const Page404 = () => import('@/components/views/Page404');
const Page401 = () => import('@/components/views/Page401');
const Main = () => import('@/components/views/Main');
const History = () => import('@/components/views/History');
const HistoryDetail = () => import('@/components/views/HistoryDetail');
const Login = () => import('@/components/views/Login');

Vue.use(Router);
export default new Router({
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes(){
  return [
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/history/:id',
      name: 'History Detail',
      component: HistoryDetail
    },
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    // {
    //   path: '/login',
    //   name: 'Login',
    //   component: Login
    // },
    {
      path: '/401',
      name: 'Page 401',
      component: Page401
    },
    {
      path: '/*',
      name: 'Page 404',
      component: Page404
    }
  ]
}
